import { Component } from '@theme/component';

export class ArticleQuickSearch extends Component {
  /** @type {Element | null} */
  stickyHost = null;

  /** @type {Element | null} */
  disabledHeader = null;

  /** @type {string | null} */
  restoredHeaderSticky = null;

  connectedCallback() {
    super.connectedCallback();

    this.#initSticky();
    this.#initPillLinks();
    this.#markActivePill();
    this.#initSearchClear();
  }

  /* On mobile the clear button only shows while the form has :focus-within, so a
     tap that moved focus off the input hid it before the click landed. Holding
     focus on press lets the click through; it then resets and collapses the bar. */
  #initSearchClear() {
    const clear = this.querySelector('.article-quick-search__search-clear');
    const input = this.querySelector('.article-quick-search__search-input');
    if (!(clear instanceof HTMLButtonElement) || !(input instanceof HTMLInputElement)) return;

    clear.addEventListener('pointerdown', (event) => event.preventDefault());
    clear.addEventListener('click', () => input.blur());
  }

  #initPillLinks() {
    const searchUrl = this.getAttribute('data-search-url');
    if (!searchUrl) return;

    for (const pill of this.querySelectorAll('.pill')) {
      if (pill instanceof HTMLAnchorElement) {
        if (!pill.getAttribute('href')) pill.setAttribute('href', searchUrl);
        continue;
      }

      const link = document.createElement('a');
      for (const attr of Array.from(pill.attributes)) {
        link.setAttribute(attr.name, attr.value);
      }
      link.setAttribute('href', searchUrl);
      link.innerHTML = pill.innerHTML;
      pill.replaceWith(link);
    }
  }

  #markActivePill() {
    const current = this.#normalizeUrl(window.location.href);
    if (!current) return;

    for (const pill of this.querySelectorAll('a.pill')) {
      const href = pill.getAttribute('href');
      const target = this.#normalizeUrl(href);
      if (target && target === current) {
        pill.classList.add('pill--active');
        pill.setAttribute('aria-current', 'page');
      }
    }
  }

  #normalizeUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      const path = url.pathname.replace(/\/+$/, '') || '/';
      return path + url.search;
    } catch {
      return '';
    }
  }

  disconnectedCallback() {
    this.stickyHost?.classList.remove('article-quick-search-sticky-host');
    document.documentElement.classList.remove('has-article-quick-search');
    if (this.disabledHeader && this.restoredHeaderSticky != null) {
      this.disabledHeader.setAttribute('sticky', this.restoredHeaderSticky);
      document.documentElement.classList.add('header-sticky');
    }
    super.disconnectedCallback();
  }

  #initSticky() {
    if (this.getAttribute('data-sticky') !== 'true') return;

    this.stickyHost = this.closest('.shopify-section');
    this.stickyHost?.classList.add('article-quick-search-sticky-host');
    document.documentElement.classList.add('has-article-quick-search');

    const header = document.querySelector('header-component');
    if (header?.hasAttribute('sticky')) {
      this.disabledHeader = header;
      this.restoredHeaderSticky = header.getAttribute('sticky');
      header.removeAttribute('sticky');
      header.removeAttribute('data-sticky-state');
      document.documentElement.classList.remove('header-sticky', 'header-sticky-active');
    }
  }
}

if (!customElements.get('article-quick-search')) {
  customElements.define('article-quick-search', ArticleQuickSearch);
}
